import { getStore } from "@/business/store/application/getStore";
import { ref, Ref, onMounted } from "vue";

export function downloadUse() {
    const route: Ref<string> = ref("");

    onMounted(async () => {
        await getStoreFromApi();
    });

    async function getStoreFromApi(): Promise<void> {
        const storeApplication = await getStore.execute();
        route.value = storeApplication.url;
    }

    return {
        route,
    };
}